import styled from 'styled-components';

export const HowWorks = styled.div`
  margin-top: 3.5rem;
  display: flex;
  text-align: center;
  justify-content: center;
  & > .icon-story-container {
    width: 25%;
    display: inline-block;
    .hefesto-icon svg {
      width: 5rem;
      height: 4.25rem;
      left: 1rem;
      top: 6rem;
    }
    .hefesto-title h4 {
      margin: auto;
      height: 7rem;
      width: 14.875rem;
      left: 1rem;
      top: 6rem;
    }
  }
`;
